import ServicePageLayout from '@/components/ServicePageLayout';

const WEDDING_DATA = {
  id: 'wedding',
  title: 'Wedding Services',
  subtitle: 'Timeless love stories, captured with cinematic elegance and heartfelt emotion.',
  category: 'Wedding',
  heroImage: '/images/Wedding/Wedding_Page_Hero_Image.jpeg',
  sections: [
    {
      id: 'wedding-coverage',
      title: 'Wedding Coverage',
      items: [
        {
          title: 'Wedding Day Coverage',
          description: 'Full-day documentation capturing absolutely every precious moment from morning preparations to the farewell. Our team ensures no detail goes unnoticed.',
          image: '/images/Wedding/Traditional.jpg',
        },
        {
          title: 'Candid Coverage',
          description: 'Natural, unscripted moments that reveal genuine emotions, stolen glances, and spontaneous connections throughout your celebration.',
          image: '/images/Wedding/Candid.jpg',
        },
        {
          title: 'Traditional Coverage',
          description: 'Timeless posed portraits and formal ceremonial documentation, preserving your family legacy with grace and dignity through meaningful visual storytelling.',
          image: '/images/Wedding/Traditional_1.jpg',
        },
      ],
    },
    {
      id: 'pre-wedding',
      title: 'Pre-Wedding & Couple',
      items: [
        {
          title: 'Pre-Wedding Shoot',
          description: 'Romantic outdoor or studio sessions that tell your cinematic love story before the big day, in breathtaking locations.',
          image: '/images/Wedding/Pre_wedding.jpg',
        },
        {
          title: 'Engagement Shoot',
          description: 'Celebrate your commitment with intimate and joyful photographs that capture the excitement of your engagement.',
          image: '/images/Wedding/Engagement.jpg',
        },
        {
          title: 'Couple Portraits',
          description: 'Elegant portrait sessions for couples, whether for anniversaries, milestones, or simply to celebrate your bond in timeless elegance.',
          image: '/images/Wedding/Couple_Portrait.jpg',
        },
      ],
    },
    {
      id: 'event-coverage',
      title: 'Event Coverage',
      items: [
        {
          title: 'Haldi Ceremony Coverage',
          description: 'Vibrant and colorful documentation of the Haldi ritual, capturing the joy and warmth of this beloved tradition shared by loved ones.',
          image: '/images/Wedding/Haldi.jpg',
        },
        {
          title: 'Mehndi Ceremony Coverage',
          description: 'Intricate mehndi designs and the festive spirit of the Mehndi celebration, documented with artistic flair.',
          image: '/images/Wedding/Mehndi.jpg',
        },
        {
          title: 'Sangeet Coverage',
          description: 'The energy and excitement of the Sangeet night — performances, dances, and celebrations captured in their full glory.',
          image: '/images/Wedding/Sangeet.jpg',
        },
        {
          title: 'Wedding Ceremony Coverage',
          description: 'Every sacred ritual, every vow, every emotional moment of the wedding ceremony documented with reverence.',
          image: '/images/Wedding/Wedding_Ceremony_Coverage.jpg',
        },
        {
          title: 'Reception Coverage',
          description: 'Grand entrances, toasts, first dances, and celebrations — your reception documented with cinematic grandeur and seamless storytelling.',
          image: '/images/Wedding/Reception.jpg',
        },
      ],
    },
    {
      id: 'portraits',
      title: 'Portraits',
      items: [
        {
          title: 'Bridal Portraits',
          description: 'Stunning solo portraits of the bride, showcasing the elegance of bridal attire, jewelry, and beauty.',
          image: '/images/Wedding/Bridal_Portraits.jpg',
        },
        {
          title: 'Groom Portraits',
          description: 'Distinguished portraits of the groom, capturing the poise and charm of the special day.',
          image: '/images/Wedding/Groom_Portraits.jpg',
        },
      ],
    },
    {
      id: 'films',
      title: 'Films',
      items: [
        {
          title: 'Cinematic Wedding Film',
          description: 'A full-length, professionally edited film that tells the complete story of your wedding day with cinematic storytelling.',
          image: '/images/Wedding/Cinematic_Wedding_Film.jpg',
        },
        {
          title: 'Highlight Film',
          description: 'A beautifully condensed film capturing the best moments of your celebration — perfect for sharing and reliving for years to come.',
          image: '/images/Wedding/Hightlight_Film.jpg',
        },
        {
          title: 'Wedding Teaser',
          description: 'A short, impactful and thoughtfully edited teaser trailer of your wedding — ideal for social media and quick sharing with loved ones.',
          image: '/images/Wedding/Teaser.jpg',
        },
      ],
    },
    {
      id: 'add-ons',
      title: 'Add-Ons',
      items: [
        {
          title: 'Drone Coverage',
          description: 'Breathtaking aerial perspectives of your venue, ceremony, and celebrations that add a cinematic dimension.',
          image: '/images/Wedding/Drone_View.jpg',
        },
        {
          title: 'Destination Wedding Coverage',
          description: 'We travel with you to capture your dream destination wedding — from beaches to mountains to palaces across diverse stunning locations.',
          image: '/images/Wedding/Destination_Wedding.jpg',
        },
        {
          title: 'Same-Day Edit',
          description: 'A professionally edited quick turnaround highlight reel delivered the same day — surprise your guests at the reception.',
          image: '/images/Wedding/Same_Day_Edit.jpg',
        },
      ],
    },
    {
      id: 'albums-deliverables',
      title: 'Albums & Deliverables',
      items: [
        {
          title: 'Wedding Albums',
          description: 'Premium handcrafted photo albums with archival-quality prints, designed to be a treasured family heirloom.',
          image: '/images/Wedding/Album.jpg',
        },
        {
          title: 'Digital Photo & Video Delivery',
          description: 'Full resolution digital files delivered via a secure cloud platform, with editing and color grading included.',
          image: '/images/Wedding/Digital_Photo_&_Video_Delivery.jpg',
        },
        {
          title: 'Online Gallery',
          description: 'A private, password-protected online gallery for easy sharing, downloading, and printing of your photos.',
          image: '/images/Wedding/Online_Gallery.jpg',
        },
      ],
    },
  ],
};

export default function WeddingPage() {
  return <ServicePageLayout data={WEDDING_DATA} />;
}
